import React from "react";
import BoardHeader from "./BoardHeader";
import BoardToolbar from "./BoardToolbar";
import DailyBoard from "./DailyBoard";
export default function DesktopBoard({ selectedDayMs, visibleRoleKeys = [], roleOptions,
  isTablet = false, dailyByBlockRole = {}, openOverflow = () => {}, cellHeightForBlock,
  visibleCardsForCount, cardHeightForCount, RoleVisibilityStrip, SelectionActionBar,
  PlannerShiftCard, LifecycleBoxes, BOARD_BLOCKS = [] }) {
  return <div className="schedule-board">
    <BoardToolbar RoleVisibilityStrip={RoleVisibilityStrip} SelectionActionBar={SelectionActionBar} />
    <div className="schedule-board-scroll" role="region" tabIndex={0}
      aria-label={"Schedule by role and time for " + new Date(selectedDayMs).toLocaleDateString()}>
      {visibleRoleKeys.length === 0 ? <p className="smallMeta">No visible role columns. Use Roles → Show all.</p> : <>
        <BoardHeader visibleRoleKeys={visibleRoleKeys} roleOptions={roleOptions} isTablet={isTablet} />
        <DailyBoard BOARD_BLOCKS={BOARD_BLOCKS} visibleRoleKeys={visibleRoleKeys} roleOptions={roleOptions}
          isTablet={isTablet} dailyByBlockRole={dailyByBlockRole} PlannerShiftCard={PlannerShiftCard}
          LifecycleBoxes={LifecycleBoxes} cardHeightForCount={cardHeightForCount}
          visibleCardsForCount={visibleCardsForCount} cellHeightForBlock={cellHeightForBlock} openOverflow={openOverflow} />
      </>}
    </div>
  </div>;
}
